function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-580.753 -89.513)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M589.693,107.861a7.134,7.134,0,0,1-5.449-2.012,1.346,1.346,0,0,1-.4-.892,1,1,0,0,1,.544-.724,1.1,1.1,0,0,1,.946.154c2.154,2.011,4.66,1.977,7.181,1.091a6.9,6.9,0,0,0,4.624-5.663,7.318,7.318,0,0,0-7.491-8.435,7.411,7.411,0,0,0-4.21,1.515.948.948,0,0,1-1.446-.073c-.347-.461-.224-.976.338-1.411a9.168,9.168,0,1,1,6.786,16.367C590.647,107.839,590.168,107.835,589.693,107.861Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M591.189,99.612h-9.142c-.854,0-1.287-.311-1.294-.918s.428-.941,1.271-.942q3.871,0,7.742,0h1.411l.057-.123q-.791-.78-1.582-1.562c-.143-.141-.292-.279-.421-.432a.926.926,0,0,1,.009-1.247.848.848,0,0,1,1.234-.087q1.935,1.867,3.808,3.8a.83.83,0,0,1-.054,1.237q-1.808,1.841-3.649,3.649a.886.886,0,0,1-1.324.009.917.917,0,0,1,.036-1.327c.638-.651,1.3-1.281,1.949-1.92Z"
}));

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#2cbbdb",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.315,
    height: 18.349,
    viewBox: "0 0 18.315 18.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e7938f03cb213b01880a0ec704f60fe5.svg";
export { ForwardRef as ReactComponent };